import { render } from "./BrandSearchSelect.vue?vue&type=template&id=5ca217f4"
import script from "./BrandSearchSelect.vue?vue&type=script&lang=js"
export * from "./BrandSearchSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/lino-guzman/code/descargas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__